// extracted by mini-css-extract-plugin
module.exports = {"extraWalletLabel":"_6837b14","promotionCheckbox":"_cbc8310","extraWalletsCloseButton":"_3745265","freeBetIcon":"_84ec99c","srOnly":"_f723cdb"};